module.exports = __webpack_public_path__ + "static/media/header_gpm.27855333.jpg";